export const GET_USER_BY_ROLE_API = "v1/users/by-role";
export const GET_USERS = "v1/users";
export const GET_USER_PENDING_BILL_COUNT = `v1/owner-users/pending-bill-count`;
export const PROPERTY_OWNERSHIP_API = "v1/property-ownerships";
export const PROPERTY_OWNERSHIP_V2_API = (communityId: string) => `v2/community/${communityId}/property-ownerships`;
export const GET_PROPERTY_OWNER_API = (propertyId: string) =>
  `${PROPERTY_OWNERSHIP_API}/property/${propertyId}`;
export const GET_PROPERTY_OWNER_BY_USER_ID_API = (id: string) =>
  `${PROPERTY_OWNERSHIP_API}/user/${id}`;
export const USER_PREFERENCE_API = "v1/user-preferences";
export const BOM_POSITION_API = "v1/bom-positions";
export const BOM_USERS_API = "v1/bom-users";
export const OWNER_ACCOUNT_DETAILS_API = "v1/owner-account-details";
export const POSITION_APPROVAL_LIMIT = "v1/position-approval-limits";
export const TNC_API = "v1/tnc";
export const DOWNLOAD_OCCUPANCY_TEMPLATE = `v1/onboarding/properties`;
export const EMPLOYEE_API = "v1/employee";
export const PROPERTY_ASSOCIATION = `v1/property-user-associations`;
export const ONBOARDING_API = (communityId: string) =>  `v1/onboarding/community/${communityId}`;

